import React, { useState } from "react";
import { useSession } from "hooks/useSession";
import { fetchWrapper } from "utils/apiFetch";

const API_BASE = "https://pro.mokshiq.in";

const ManualPayoutStatusModal = ({ show, onClose, transaction, onUpdated }) => {
  const { token } = useSession(); // adjust if your auth token lives elsewhere
  const [rrn, setRrn] = useState(transaction?.bank_rrn || "");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [pendingStatus, setPendingStatus] = useState(null); // "SUCCESS" | "FAILED"

  if (!show || !transaction) return null;

  const requestId = transaction.ref_no || transaction.id;

  const submitStatus = async (status) => {
    if (!rrn.trim()) {
      setError("Bank RRN is required");
      return;
    }
    setError("");
    setLoading(true);
    setPendingStatus(status);

    try {
      const formData = new FormData();
      formData.append("requestId", requestId);
      formData.append("rrn", rrn.trim());
      formData.append("status", status);

      const data = await fetchWrapper(`${API_BASE}/mannual_payout_status_update`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`, // adjust to your actual auth scheme
        },
        body: formData,
      });

      

      if (data.status) {
        onUpdated && onUpdated({ requestId, status, rrn: rrn.trim() });
        onClose();
      } else {
        setError(data.message || "Something went wrong");
      }
    } catch (err) {
      setError("Network error — please try again");
    } finally {
      setLoading(false);
      setPendingStatus(null);
    }
  };

  return (
    <div
      className="modal d-block"
      tabIndex="-1"
      style={{ background: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Manual Status Update</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              disabled={loading}
            />
          </div>

          <div className="modal-body">
            <div className="mb-3">
              <label className="form-label">Request ID</label>
              <input
                type="text"
                className="form-control"
                value={requestId || ""}
                disabled
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Current Status</label>
              <input
                type="text"
                className="form-control"
                value={transaction.status || ""}
                disabled
              />
            </div>

            <div className="mb-3">
              <label className="form-label">
                Bank RRN <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                value={rrn}
                onChange={(e) => setRrn(e.target.value)}
                placeholder="Enter bank RRN"
                disabled={loading}
              />
            </div>

            {error && <div className="alert alert-danger py-2">{error}</div>}
          </div>

          <div className="modal-footer">
            <button
              className="btn btn-secondary"
              onClick={onClose}
              disabled={loading}
            >
              Cancel
            </button>
            <button
              className="btn btn-danger"
              onClick={() => submitStatus("FAILED")}
              disabled={loading}
            >
              {loading && pendingStatus === "FAILED" ? (
                <span className="spinner-border spinner-border-sm me-1" />
              ) : null}
              Mark Failed
            </button>
            <button
              className="btn btn-success"
              onClick={() => submitStatus("SUCCESS")}
              disabled={loading}
            >
              {loading && pendingStatus === "SUCCESS" ? (
                <span className="spinner-border spinner-border-sm me-1" />
              ) : null}
              Mark Success
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManualPayoutStatusModal;